<template>
  <main>
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="form-inline">
            <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword"
                          :placeholder="$t('keyword')" v-on:keydown.enter="search"></b-form-input>
            <form-select :model="filterFormModel" attribute="status" class="mr-1 mb-1" :options="[
                {value: 0, text: $t('all')},
                {value: 1, text: $t('activated')},
                {value: 2, text: $t('deactivated')}
            ]"></form-select>
            <client-select v-if="!client && !zaloOA" :model="filterFormModel" class="mr-1 mb-1" attribute="client"
                           @change="search"
                           :isFilter="true" :place-holder="$t('selectClient') "></client-select>
            <form-select :model="filterFormModel" attribute="type" class="mr-1 mb-1" :options="[
                {value: null, text: $t('selectType')},
                {value: 'zns', text: 'Zalo ZBS'},
                {value: 'zalo', text: 'Zalo OA'},
            ]"></form-select>
            <social-net-work-account-select :disabled="!!zaloOA" :model="filterFormModel" class="mr-1 mb-1"
                                            attribute="oa" @change="search"
                                            :isFilter="true" :filter="oaFilter" :is-filter="true"/>

            <button @click="search" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="c-sorting"
             v-if="['owner', 'admin', 'tech', 'account', 'operationsManager'].includes($store.state.user.role)">
          <div class="row">
            <div class="col-lg-6 c-sorting__left">
              <b-dropdown v-if="checkedItems.length" id="dropdown-left" :text="$t('selected', [checkedItems.length])"
                          variant="secondary"
                          size="sm">
                <b-dropdown-item @click="showUpdate = true">{{ $t('getInfo') }}</b-dropdown-item>
              </b-dropdown>
            </div>
            <div class="col-lg-6 c-sorting__right">
              <div class="c-sorting__btn">
                <button @click="create" class="btn btn-sm btn-success">
                  <font-awesome-icon icon="plus"/>&nbsp;{{ $t('create') }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{
              $t('listSummary', [firstItemOfPage, lastItemOfPage, new Intl.NumberFormat().format(itemCount), 'template'])
            }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right"
                            size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize"
                            @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title check-row">
            <div class="col-lg-3 check-column">
              {{ $t('client') }}
              <b-form-checkbox :class="`check-form ${checkedItems.length === items.length ? '' : 'hide'}`"
                               v-model="selectAll" @change="select"></b-form-checkbox>
            </div>
            <div class="col-lg-2">Zalo OA</div>
            <div class="col-lg-4">{{ $t('info') }}</div>
            <div class="col-lg-3"></div>
          </div>
          <div class="row check-row" v-for="item in items" :key="item._id">
            <div class="col-lg-3 check-column">
              <b-form-checkbox
                  :class="`check-form ${checkedItems.find(checkedItem => checkedItem._id === item._id) ? '' : 'hide'}`"
                  :value="item" v-model="checkedItems" @change="updateCheckAll"></b-form-checkbox>
              <span v-if="item.client && item.client.companyName">{{ item.client.companyName }}</span>
              <span v-if="item.client && item.client.domain">({{ item.client.domain }})</span>
            </div>
            <div class="col-lg-2">
              <span v-if="item.oa">{{ item.oa.name }} ({{ item.oa.oaId }})</span>
            </div>
            <div class="col-lg-4">
              <p>
                <b>{{ $t('name') }}: </b>{{ item.name }}
                <a v-if="item.previewUrl" :href="item.previewUrl" target="_blank"
                   class="small">({{ $t('seePreview') }})</a>
              </p>
              <p>
                <b>{{ $t('type') }}: </b>{{ item.type ? $t(item.type) : $t('unknown') }}
              </p>
              <p><b>{{ $t('price') }}: </b>{{ item.price }} đ</p>
              <p v-if="item.refId"><b>Zalo template Id: </b>{{ item.refId }}</p>
              <p v-if="item.quality">
                <b>{{ $t('templateQuality') }}: </b><span>{{ item.quality }}</span>
              </p>
              <p v-if="item.tag">
                <b>{{ $t('templateTag') }}: </b><span>{{ item.tag }}</span>
              </p>
              <p>
                <span v-if="item.active" class="badge badge-success">{{ $t('activated') }}</span>
                <span v-else class="badge badge-danger">{{ $t('deactivated') }}</span>

                <span v-if="['otp', 'text', 'table', 'rating'].includes(item.type)"
                      class="badge badge-info ml-1">ZBS</span>
                <span v-else class="badge badge-primary ml-1">OA Message</span>

              </p>
            </div>
            <div class="col-lg-3">
              <div class="c-smart-table__content">
                <div class="c-buttons clearfix is-2 text-right">
                  <div class="c-buttons__col" v-if="['otp', 'text', 'table', 'rating'].includes(item.type)">
                    <button @click="showParams(item.params)" class="btn btn-sm btn-primary mr-1">
                      <font-awesome-icon icon="list"/>&nbsp;{{ $t('params') }}
                    </button>
                    <button @click="getInfo(item._id)" type="button"
                            v-if="['owner','admin', 'account', 'tech', 'operationsManager'].includes($store.state.user.role) && item.refId"
                            class="btn btn-sm btn-warning mr-1">
                      <b-spinner small v-if="getInfoLoading"></b-spinner>
                      <font-awesome-icon v-else icon="info"/>&nbsp;{{ $t('getInfo') }}
                    </button>
                  </div>
                  <div class="c-buttons__col"
                       v-if="['owner', 'admin', 'tech', 'account', 'operationsManager'].includes($store.state.user.role)">
                    <button @click="update(item._id)" type="button"
                            v-if="['owner','admin','tech', 'account', 'operationsManager'].includes($store.state.user.role)"
                            class="btn btn-sm btn-info mr-1">
                      <font-awesome-icon icon="edit"/>&nbsp;{{ $t('edit') }}
                    </button>
                    <button @click="del(item._id)" type="button"
                            v-if="['owner', 'admin', 'tech', 'account'].includes($store.state.user.role)"
                            class="btn btn-sm btn-danger mr-1">
                      <font-awesome-icon icon="trash"/>&nbsp;{{ $t('delete') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span>{{ $t('notFoundSearch') }}</span>
      </div>
      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{
            $t('listSummary', [firstItemOfPage, lastItemOfPage, new Intl.NumberFormat().format(itemCount), 'template'])
          }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount"
                      :per-page="filterFormModel.pageSize"
                      @input="load"></b-pagination>
      </div>
    </div>
    <b-modal v-model="showForm" :title="formTitle" no-close-on-backdrop no-enforce-focus size="lg">
      <form>
        <client-select :disabled="formModel._id" :label="$t('client')" :model="formModel" attribute="client"
                       :errors="formErrors"></client-select>
        <social-net-work-account-select label="Zalo OA" :model="formModel" attribute="oa" :filter="oaFilter"/>
        <form-select :model="formModel" attribute="type" :errors="formErrors" :label="$t('type')" :options="[
            {value: 'otp', text: 'OTP'},
            {value: 'text', text: $t('text')},
            {value: 'table', text: $t('table')},
            {value: 'rating', text: $t('rating')}
        ]"></form-select>
        <form-input label="Zalo template id" :model="formModel" attribute="refId" :errors="formErrors"></form-input>
        <form-input :label="$t('name')" :model="formModel" attribute="name" :errors="formErrors"></form-input>
        <form-textarea :label="$t('desc')" :model="formModel" attribute="desc" :errors="formErrors"
                       :row="5" :description="`Tên biến yêu cầu thay đổi về định dạng {ten_bien}`"/>
        <form-input type="number" :label="$t('price')" :model="formModel" :errors="formErrors"
                    attribute="price"></form-input>
        <form-checkbox :chk-label="$t('activated')" :model="formModel" attribute="active"
                       :errors="formErrors"></form-checkbox>
      </form>
      <template v-slot:modal-footer>
        <button @click="showForm=false" class="btn btn-secondary">{{ $t('cancel') }}</button>
        <button @click="save" class="btn btn-primary">{{ $t('save') }}</button>
      </template>
    </b-modal>
    <b-modal v-model="showParamsModel" :title="$t('paramList')" no-close-on-backdrop no-enforce-focus size="xl">
      <div class="col-12" v-if="params && params.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-2">{{ $t('name') }}</div>
            <div class="col-lg-2">{{ $t('require') }}</div>
            <div class="col-lg-2">{{ $t('dataType') }}</div>
            <div class="col-lg-2">{{ $t('maxLength') }}</div>
            <div class="col-lg-2">{{ $t('minLength') }}</div>
            <div class="col-lg-2">{{ $t('acceptNull') }}</div>
          </div>
          <div class="row" v-for="item in params" :key="item._id">
            <div class="col-lg-2">{{ item.name }}</div>
            <div class="col-lg-2">{{ item.require ? $t('yes') : $t('no') }}</div>
            <div class="col-lg-2">{{ item.dataType }}</div>
            <div class="col-lg-2">{{ item.maxLength }}</div>
            <div class="col-lg-2">{{ item.minLength }}</div>
            <div class="col-lg-2">{{ item.acceptNull ? $t('yes') : $t('no') }}</div>
          </div>
        </div>
      </div>
      <div v-else class="text-center">{{ $t('noParamFound') }}</div>
    </b-modal>

    <b-modal v-model="showUpdate" no-close-on-backdrop scrollable :title="$t('massUpdate')" size="lg" @close="close">
      <p>{{ $t('listToUpdate') }}</p>
      <div class="c-template-table table-responsive mb-0">
        <table class="table table-bordered table-more table-hover">
          <thead>
          <tr>
            <th class="text-center">#</th>
            <th>{{ $t('client') }}</th>
            <th>{{ $t('info') }}</th>
            <th class="text-center">{{ $t('result') }}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(data, index) in checkedItems" :key="data._id">
            <td class="text-center" style="align-content: center">{{ index + 1 }}</td>
            <td style="align-content: center">
              <span v-if="data.client && data.client.companyName">{{ data.client.companyName }}</span>
              <span v-if="data.client && data.client.domain"> ({{ data.client.domain }})</span>
            </td>
            <td style="align-content: center">
              <p>
                <b>{{ $t('name') }}: </b>{{ data.name }}
                <a v-if="data.previewUrl" :href="data.previewUrl" target="_blank"
                   class="small">({{ $t('seePreview') }})</a>
              </p>
              <p>
                <b>{{ $t('type') }}: </b>{{ data.type ? $t(data.type) : $t('unknown') }}
              </p>
              <p><b>{{ $t('price') }}: </b>{{ data.price }} đ</p>
              <p v-if="data.refId"><b>Zalo template Id: </b>{{ data.refId }}</p>
              <p v-if="data.oa"><b>Zalo OA: </b>{{ data.oa.name }} ({{ data.oa.oaId }})</p>
              <p v-if="data.quality">
                <b>{{ $t('templateQuality') }}: </b><span>{{ data.quality }}</span>
              </p>
              <p v-if="data.tag">
                <b>{{ $t('templateTag') }}: </b><span>{{ data.tag }}</span>
              </p>
            </td>
            <td class="text-center" style="align-content: center">
              <span :for="`result_${data._id}`"></span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="secondary" class="float-right" @click="close">
          {{ $t('cancel') }}
        </b-button>
        <b-button :disabled="massUpdateLoading" variant="primary" class="float-right" @click="startUpdate">
          <b-spinner v-if="massUpdateLoading" small></b-spinner>
          {{ $t('update') }}
        </b-button>
      </template>
    </b-modal>
  </main>
</template>

<script>
import list from '@/mixins/List';
import crud from '@/mixins/CRUD';
import SocialNetWorkAccountSelect from "@/components/SocialNetWorkAccountSelect";
import ClientSelect from "@/components/ClientSelect";
import _ from 'lodash';
import $ from "jquery";

export default {
  props: {
    client: Object,
    zaloOA: Object,
  },
  mixins: [list, crud],
  components: {ClientSelect, SocialNetWorkAccountSelect},
  data: function () {
    return {
      defaultFilterFormModel: {
        status: 1,
        client: this.client ? this.client._id : null,
        oa: this.zaloOA ? this.zaloOA._id : null,
        type: null,
        keyword: null
      },
      autoLoad: true,
      service: '/zns-template',
      defaultFormModel: {
        status: 1,
        client: this.client ? this.client._id : null,
        oa: null,
        type: 'text'
      },
      oaFilter: {
        type: "zalo",
        client: this.client ? this.client._id : null,
      },
      showParamsModel: false,
      params: [],
      getInfoLoading: false,
      checkedItems: [],
      selectAll: false,
      showUpdate: false,
      massUpdateLoading: false,
      firstItemOfPage: 0,
      lastItemOfPage: 0,
    }
  },
  watch: {
    "formModel.client": {
      handler(val) {
        this.oaFilter.client = val;
      }
    }
  },
  methods: {
    search: _.debounce(function () {
      this.filterFormModel.page = 1;
      this.load();
    }, 200),
    showParams(params) {
      this.params = params;
      this.showParamsModel = true;
    },
    getInfo(id) {
      this.$swal({
        title: this.$t('getInfoConfirm'),
        icon: "warning",
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          this.getInfoLoading = true;
          this.$service.get('/zns-template/info/' + id).then(response => {
            if (response && response.data) {
              this.$swal({
                icon: 'success',
                text: this.$t('updated'),
                toast: true,
                timer: 5,
                position: "top-right"
              });
              this.load();
            } else {
              this.$swal({
                icon: 'error',
                text: this.$t('updateFailed'),
              })
            }
          }).catch(error => {
            if (error.response.data.message) {
              this.$swal({
                text: error.response.data.message,
                icon: 'error'
              });
              this.showForm = false;
            }
          }).finally(() => {
            this.getInfoLoading = false;
          })
        }
      })
    },
    select() {
      this.checkedItems = []
      if (this.selectAll) {
        this.items.forEach((item, index) => {
          this.checkedItems.push(this.items[index])
        })
      }
    },
    updateCheckAll() {
      this.selectAll = this.items.length === this.checkedItems.length
    },
    close() {
      this.showUpdate = false
      this.selectAll = false
      this.checkedItems = []
    },
    async startUpdate() {
      this.$swal({
        title: this.$t('getInfoConfirm'),
        icon: "warning",
        showCancelButton: true
      }).then(async (result) => {
        if (result.value) {
          this.massUpdateLoading = true
          let i = 0
          let successCount = 0
          $(`span[for^=result]`).html('<div class="spinner-border spinner-border-sm text-primary" role="status"><span class="sr-only">Loading...</span></div>')

          while (this.showUpdate && i < this.checkedItems.length) {
            let data = this.checkedItems[i]
            i++
            try {
              let response
              response = await this.$bgService.get(this.service + '/info/' + data._id)
              if (response) {
                successCount++
                $(`span[for=result_${data._id}]`).html(`<span class="badge badge-success">${this.$t('success')}</span>`)
              } else {
                $(`span[for=result_${data._id}]`).html(`<span class="badge badge-danger">${this.$t('fail')}</span>`)
              }
            } catch (e) {
              $(`span[for=result_${data._id}]`).html(`<span class="text-danger">${e.response.data.message}</span>`)
            }
          }
          if (successCount === this.checkedItems.length) {
            this.$swal({
              title: this.$t('success'),
              text: this.$t('updated'),
              icon: 'success',
              toast: true,
              position: 'top-end',
              timer: 5000
            })
          }
          this.massUpdateLoading = false
          this.load()
        }
      })
    },
    apply: function (data) {
      this.items = data.docs;
      this.itemCount = data.totalDocs;
      this.firstItemOfPage = this.itemCount > 0 ? (this.filterFormModel.page - 1) * this.filterFormModel.pageSize + 1 : 0;
      this.lastItemOfPage = (this.filterFormModel.page - 1) * this.filterFormModel.pageSize + this.items.length;
    }
  },
  i18n: {
    messages: {
      en: {
        seePreview: 'See preview',
        params: 'Params',
        noParamFound: 'No param found',
        paramList: 'Param list',
        require: 'Require',
        dataType: 'Data type',
        maxLength: 'Max length',
        minLength: 'Min length',
        acceptNull: 'Accept null',
        text: 'Text',
        table: 'Table',
        dailyQuota: 'Daily quota',
        remainingQuota: 'Remaining quota',
        templateQuality: 'Template quality',
        getInfo: 'Get template info',
        rating: 'Rating',
        selectType: "Select type",
        cs: "Consulting message",
        image: "Consulting message with photo attached",
        promotion: "Personal media message",
        transaction: "Transactional message",
        templateTag: "Loại nội dung",
        getInfoConfirm: "Are you sure you want to update the template information?",
        selected: 'Choose action (Selected {0})',
        massUpdate: 'Update template information in bulk',
        listToUpdate: 'The template list will be updated with information',
        listSummary: "Showing {0}-{1}/{2} {3}(s)",
        result: "Result",
      },
      vi: {
        seePreview: 'Xem trước',
        params: 'Tham số',
        noParamFound: 'Chưa có param nào',
        paramList: 'Danh sách tham số',
        require: 'Bắt buộc',
        dataType: 'Loại dữ liệu',
        maxLength: 'Độ dài tối đa',
        minLength: 'Độ dài tối thiểu',
        acceptNull: 'Chấp nhận giá trị null',
        text: 'Dạng chữ',
        table: 'Dạng bảng',
        dailyQuota: 'Hạn mức trong ngày',
        remainingQuota: 'Hạn mức còn lại',
        templateQuality: 'Chất lượng gửi tin',
        getInfo: 'Cập nhật thông tin template',
        rating: 'Đánh giá dịch vụ',
        selectType: "Chọn loại",
        cs: "Tin tư vấn",
        image: "Tin tư vấn đính kèm ảnh",
        promotion: "Tin truyền thông cá nhân",
        transaction: "Tin giao dịch",
        templateTag: "Loại nội dung",
        getInfoConfirm: "Bạn chắc chắn muốn cập nhật thông tin template chứ?",
        selected: 'Chọn hành động (Đã chọn {0})',
        massUpdate: 'Cập nhật hàng loạt thông tin template',
        listToUpdate: 'Danh sách template sẽ được cập nhật thông tin',
        listSummary: "Đang xem {0}-{1}/{2} {3}",
        result: "Kết quả",
      }
    }
  }
}
</script>

<style>
.check-column {
  position: relative;
}

.check-form {
  position: absolute;
  top: 0;
  right: 0;
}

.check-form.hide {
  display: none;
}

.check-row:hover .check-form {
  display: block;
}
</style>